/**
 * Created by Vladislav on 24.09.2024.
 */

const AvatarMenuBarItem = {
    name: "AvatarItem",
    targets: ["exp"],
    viewClass: AvatarMenuBarView,
    modelClass: AvatarMenuBarItemModel,
    availableOnScenes: function () {
        return [cleverapps.Environment.SCENE_MAIN];
    }
};
